// extracted by mini-css-extract-plugin
module.exports = {"scrollbody":"createJdModal_scrollbody__3juee"};